import { PlayfulThemeId } from '../identifiers';
import { PlayfulThemeDefinition } from '../types';
import { IconName } from '@/icons/types';
import { OceanMascot } from '@/components/core/ThemeMascot/mascots';

export const oceanWavesTheme: PlayfulThemeDefinition = {
  id: PlayfulThemeId.OCEAN_WAVES,
  hover: {
    transform: 'translateY(-4px) rotate(-1deg)',
    transition: 'transform 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
  },
  click: {
    transform: 'scale(0.96) rotate(1deg)',
    transition: 'transform 0.2s ease-out',
  },
  idle: {
    animationName: 'playful-ocean-sway',
    animationDuration: '3.5s',
    animationTimingFunction: 'ease-in-out',
    animationIterationCount: 'infinite',
  },
  dragStart: {
    transform: 'scale(1.03) rotate(2deg)',
    transition: 'transform 0.25s ease-out',
  },
  particles: {
    enabled: true,
    count: 6,
    characters: ['🫧', '💧', '🐚', '🌊'],
    spread: 50,
    duration: 1400,
    size: 14,
  },
  keyframes: [
    {
      name: 'playful-ocean-sway',
      css: `@keyframes playful-ocean-sway {
  0%, 100% { transform: translateX(0) rotate(0deg); }
  25% { transform: translateX(2px) rotate(0.5deg); }
  75% { transform: translateX(-2px) rotate(-0.5deg); }
}`,
    },
  ],
  sounds: {
    hover: { name: 'ui/button_soft', volume: 0.12, rate: 0.7 },
    click: { name: 'notification/popup', volume: 0.2 },
  },
  metadata: {
    label: 'Ocean Waves',
    icon: IconName.WAVES,
    previewEmoji: '🌊',
    description: 'Gentle wave motion',
    mascotEmoji: '🐚',
    mascotComponent: OceanMascot,
  },
};
